v-menu(v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto")
  template(v-slot:activator="{ props }")
      v-text-field(
        v-model="displayValue"
        :label="date_label"
          :rules="date_rules"
        prepend-inner-icon="mdi-calendar" 
        v-bind="props" 
        :error="!!errorMessage" 
        :error-messages="errorMessage" 
        @input="handleTextInput" 
        @keydown="restrictKeys" 
        @blur="validateOnBlur"
      )

  v-date-picker(v-model="internalDate" no-title scrollable)
